import React, { useState } from "react";
import ConfirmationDialog from "../StaffPortal/ConfirmationDialog";
import { toast } from "react-toastify";

const rejectionReasonsList = [
  "Property documents not clear",
  "Not satisfied with legal documents",
  "Higher active accounts",
  "Settlement amount",
  "Suit-file, written-off",
  "Irregular payments",
  "Business not valid",
  "No proper Tax filings",
  "No GST",
  "No Transactions statement",
];

const ReviewActionsBP = ({ handleApplicationStatus }) => {
  const [isApproveDialogOpen, setIsApproveDialogOpen] = useState(false);
  const [isRejectDialogOpen, setIsRejectDialogOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");

  const openApproveDialog = () => {
    setIsApproveDialogOpen(true);
  };

  const closeApproveDialog = () => {
    setIsApproveDialogOpen(false);
  };

  const openRejectDialog = () => {
    setIsRejectDialogOpen(true);
  };

  const closeRejectDialog = () => {
    setIsRejectDialogOpen(false);
  };

  const toggleReason = (reason) => {
    setSelectedReason(reason);
    toast.info(`Rejection Reason: ${reason}`);
  };

  const handleReject = () => {
    const reasonToSend = selectedReason || "No rejection reason provided";
    handleApplicationStatus("rejected", reasonToSend);
    setDropdownOpen(false);
    setSelectedReason("");
  };

  return (
    <>
      <div className="relative flex flex-col sm:flex-row justify-between bg-[#131313] rounded-lg p-4 gap-3 sm:gap-0">
        {dropdownOpen && (
          <div className="absolute bottom-full mb-2 z-50 border border-red-600 rounded-md p-2 w-full sm:w-[300px] bg-[#1e1e1e]">
            <h4 className="text-white mb-2 font-medium">
              Select Rejection Reason:
            </h4>
            <div className="max-h-48 overflow-y-auto">
              {rejectionReasonsList.map((reason) => (
                <label
                  key={reason}
                  className="flex items-start px-2 py-1 text-white hover:bg-red-800 rounded cursor-pointer"
                >
                  <input
                    type="radio"
                    name="rejectionReason"
                    className="mr-2 mt-1 flex-shrink-0"
                    checked={selectedReason === reason}
                    onChange={() => toggleReason(reason)}
                  />
                  <span className="break-words">{reason}</span>
                </label>
              ))}
            </div>
          </div>
        )}
        <div className="flex flex-col sm:flex-row gap-2">
          <button
            onClick={() => {
              if (dropdownOpen) {
                handleReject();
              } else {
                setDropdownOpen(true);
              }
            }}
            className={`bg-red-500 text-white px-4 py-2 rounded-md flex items-center justify-center text-center ${
              dropdownOpen ? "w-full sm:w-[300px]" : "w-full sm:w-auto"
            }`}
          >
            <span className="mr-2">⨯</span>
            {dropdownOpen ? "Confirm Rejection 🚫" : "Reject Application"}
          </button>
          {dropdownOpen && (
            <button
              onClick={() => {
                setDropdownOpen(false);
              }}
              className="bg-gray-500 text-white px-4 py-2 rounded-md flex items-center justify-center text-center w-full sm:w-auto"
            >
              <span className="mr-2">⨯</span> Cancel
            </button>
          )}
        </div>
        <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 space-x-0 sm:space-x-4 flex-1 sm:flex-none">
          <div className="relative flex-1 sm:flex-none">
            <button
              onClick={openApproveDialog}
              className={`flex items-center px-4 py-2 rounded-md bg-green-500 text-white w-full`}
            >
              Approve Application
            </button>
          </div>
        </div>
      </div>

      <ConfirmationDialog
        isOpen={isApproveDialogOpen}
        onClose={closeApproveDialog}
        onConfirm={() => {
          handleApplicationStatus("approved");
          closeApproveDialog();
        }}
        title="Approve Application"
        message="Are you sure you want to approve this application?"
      />


    </>
  );
};

export default ReviewActionsBP;
